import * as Sentry from '@sentry/browser';
import { getSharedConfig } from '../common/helpers/configs';

export function initSentry() {
  const config = getSharedConfig();
  if (config.sentryDSN) {
    Sentry.init({
      release: process.env.REACT_APP_VERSION,
      dsn: config.sentryDSN,
    });
  }
}
